import { render, staticRenderFns } from "./Popup-terms.vue?vue&type=template&id=93a5f9a2&"
import script from "./Popup-terms.vue?vue&type=script&lang=ts&"
export * from "./Popup-terms.vue?vue&type=script&lang=ts&"
import style1 from "./Popup-terms.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports